<p-menubar>
    <ng-template pTemplate="start">
        <label class="font-semibold">
            Atualização de Alíquota de IPI - XML vs Sistema
        </label>
    </ng-template>
</p-menubar>

<!-- Seção de Upload com toggle (só aparece no modo direto, sem dados pré-carregados) -->
<div *ngIf="modoDireto" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-card>
            <div class="flex align-items-center justify-content-between mb-3 pb-3 border-bottom-1 surface-border">
                <div class="flex align-items-center gap-2">
                    <button pButton type="button"
                        [icon]="secaoUploadExpandida ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                        (click)="toggleSecaoUpload()" class="p-button-rounded p-button-text p-button-sm"
                        pTooltip="{{secaoUploadExpandida ? 'Recolher' : 'Expandir'}}" tooltipPosition="right"></button>
                    <h5 class="m-0">Selecione os arquivos XML (DUIMP)</h5>
                    <p-badge *ngIf="!secaoUploadExpandida && arquivosSelecionados.length > 0"
                        [value]="arquivosSelecionados.length.toString()" severity="info"></p-badge>
                </div>

                <div class="flex gap-2" *ngIf="secaoUploadExpandida">
                    <input #fileInput type="file" accept=".xml" multiple (change)="onFileChange($event)"
                        style="display: none">

                    <button pButton type="button" icon="pi pi-plus" label="Selecionar XMLs" (click)="fileInput.click()"
                        class="p-button-sm p-button-outlined" style="white-space: nowrap;"></button>

                    <button pButton type="button" icon="pi pi-trash" label="Limpar Todos" (click)="limparArquivos()"
                        [disabled]="arquivosSelecionados.length === 0"
                        class="p-button-sm p-button-outlined p-button-danger" style="white-space: nowrap;"></button>
                </div>
            </div>

            <div *ngIf="secaoUploadExpandida">
                <div class="flex flex-column gap-3">
                    <div *ngIf="arquivosSelecionados.length > 0">
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-file mr-2"></i>
                                <b>Arquivos selecionados ({{arquivosSelecionados.length}})</b>
                            </div>
                        </p-divider>

                        <div class="flex flex-column gap-2">
                            <div *ngFor="let file of arquivosSelecionados; let i = index"
                                class="flex justify-content-between align-items-center p-3 surface-ground border-round">
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-file-pdf text-2xl text-primary"></i>
                                    <div class="flex flex-column">
                                        <span class="font-semibold">{{file.name}}</span>
                                        <span class="text-sm text-500">{{formatFileSize(file.size)}}</span>
                                    </div>
                                </div>
                                <button pButton type="button" icon="pi pi-times" (click)="removerArquivo(i)"
                                    class="p-button-rounded p-button-text p-button-danger"></button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="arquivosSelecionados.length === 0"
                        class="text-center p-4 surface-ground border-round border-2 border-dashed surface-border">
                        <i class="pi pi-cloud-upload text-4xl text-400 mb-3"></i>
                        <p class="m-0 text-500">Nenhum arquivo selecionado</p>
                        <p class="m-0 text-sm text-400">Clique em "Selecionar XMLs" para começar</p>
                    </div>

                    <div *ngIf="erroUpload" class="p-3 surface-ground border-round border-left-3 border-red-500">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-exclamation-circle text-xl text-red-500"></i>
                            <span class="text-red-600 font-semibold">{{erroUpload}}</span>
                        </div>
                    </div>

                    <div class="flex justify-content-center mt-3">
                        <button pButton type="button" icon="pi pi-check" label="Processar XMLs"
                            (click)="processarXMLs()" [disabled]="arquivosSelecionados.length === 0 || carregando"
                            [loading]="carregando" class="p-button-lg p-button-success w-full md:w-auto"></button>
                    </div>
                </div>
            </div>
        </p-card>
    </div>
</div>

<!-- Mensagem de erro fora do modo direto (ex.: erro ao comparar os itens já recebidos) -->
<div *ngIf="!modoDireto && erroUpload" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12 p-3 surface-ground border-round border-left-3 border-red-500">
        <div class="flex align-items-center gap-2">
            <i class="pi pi-exclamation-circle text-xl text-red-500"></i>
            <span class="text-red-600 font-semibold">{{erroUpload}}</span>
        </div>
    </div>
</div>

<!-- Filtros com botões de ação na mesma linha -->
<div *ngIf="comparacoesIpi.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-card>
            <div class="flex align-items-center justify-content-between gap-3">
                <div class="flex gap-3 align-items-center">
                    <span class="font-semibold">Filtros:</span>
                    <p-checkbox [(ngModel)]="filtroIpiDiferente"
                               [binary]="true"
                               label="Apenas Alíquotas Diferentes"
                               (onChange)="atualizarCheckboxMaster()"
                               inputId="filtroIpiDiferente"></p-checkbox>
                </div>

                <div class="flex gap-2 align-items-center" style="flex-shrink: 0;">
                    <button *ngIf="totalDiferentes > 0" type="button" pButton icon="pi pi-check-square"
                        label="Selecionar Todos Diferentes" (click)="toggleTodosDiferentes()"
                        class="p-button-sm p-button-outlined" style="white-space: nowrap;"></button>

                    <button *ngIf="totalSelecionados > 0" type="button" pButton icon="pi pi-check"
                        [label]="'Atualizar Selecionados (' + totalSelecionados + ')'" (click)="atualizarSelecionados()"
                        [disabled]="carregandoAtualizacao" class="p-button-sm p-button-warning"
                        style="white-space: nowrap;"></button>

                    <button *ngIf="totalDiferentes > 0" type="button" pButton icon="pi pi-sync"
                        label="Atualizar Todos Diferentes" (click)="atualizarTodosDiferentes()"
                        [disabled]="carregandoAtualizacao" class="p-button-sm p-button-warning"
                        style="white-space: nowrap;"></button>

                    <button *ngIf="totalAtualizaveis > 0" type="button" pButton icon="pi pi-refresh"
                        label="Atualizar Todos (Iguais + Diferentes)" (click)="atualizarTodos()"
                        [disabled]="carregandoAtualizacao" class="p-button-sm p-button-outlined"
                        style="white-space: nowrap;"
                        pTooltip="Atualiza a alíquota de IPI e reaplica o NCM nos itens de TODOS os NCMs cadastrados, inclusive os que já estão iguais"
                        tooltipPosition="top"></button>
                </div>
            </div>
        </p-card>
    </div>
</div>

<!-- Estatísticas -->
<div *ngIf="comparacoesIpi.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-blue-500">{{totalItens}}</span>
                <span class="text-sm text-500">Total de NCMs</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-green-500">{{totalIguais}}</span>
                <span class="text-sm text-500">Alíquotas Iguais</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-orange-500">{{totalDiferentes}}</span>
                <span class="text-sm text-500">Alíquotas Diferentes</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-red-500">{{totalNaoCadastrados}}</span>
                <span class="text-sm text-500">NCMs Não Cadastrados</span>
            </div>
        </p-card>
    </div>
</div>

<!-- Tabela de Resultados -->
<div *ngIf="comparacoesIpi.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-table [value]="comparacoesExibidas" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
            [scrollable]="true" responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-gridlines">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50px" class="text-center">
                        <p-checkbox [binary]="true" [(ngModel)]="checkboxMasterSelecionado"
                            (onChange)="toggleTodosDiferentes()" [disabled]="totalDiferentes === 0"></p-checkbox>
                    </th>
                    <th style="width: 120px">NCM</th>
                    <th style="width: 220px">P/Ns</th>
                    <th style="width: 120px" class="text-center">IPI Atual</th>
                    <th style="width: 120px" class="text-center">IPI Novo</th>
                    <th style="width: 80px" class="text-center">Status</th>
                    <th style="width: 200px">Arquivo</th>
                    <th>Descrição</th>
                    <th style="width: 100px" class="text-center">Ações</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr [ngClass]="{'bg-red-50': item.ncmEncontrado === false,
                                'bg-orange-50': item.ipiDiferente && item.ncmEncontrado !== false,
                                'bg-green-50': !item.ipiDiferente && item.ncmEncontrado !== false}">
                    <td class="text-center">
                        <p-checkbox *ngIf="item.ncmEncontrado !== false"
                            [binary]="true" [(ngModel)]="item.selecionado"
                            (onChange)="toggleSelecao(item)"></p-checkbox>
                    </td>
                    <td>
                        <span class="font-mono font-semibold">{{item.ncm}}</span>
                    </td>
                    <td>
                        <span class="text-sm" [pTooltip]="item.pns?.join(', ')" tooltipPosition="top">
                            {{item.pns && item.pns.length > 0 ? item.pns.join(', ') : '-'}}
                        </span>
                        <p-badge *ngIf="item.pns && item.pns.length > 0" [value]="item.pns.length.toString()"
                            severity="info" styleClass="ml-1"></p-badge>
                    </td>
                    <td class="text-center">
                        <span *ngIf="item.ncmEncontrado === false" class="text-red-600">-</span>
                        <span *ngIf="item.ncmEncontrado !== false"
                              [ngClass]="{'text-orange-600': item.ipiDiferente, 'text-green-600': !item.ipiDiferente}">
                            <ng-container *ngIf="item.aliquotaIpiAtualEnt === item.aliquotaIpiAtualSai">
                                {{item.aliquotaIpiAtualEnt | number:'1.2-4'}}
                            </ng-container>
                            <ng-container *ngIf="item.aliquotaIpiAtualEnt !== item.aliquotaIpiAtualSai">
                                Ent: {{item.aliquotaIpiAtualEnt | number:'1.2-4'}} / Sai: {{item.aliquotaIpiAtualSai | number:'1.2-4'}}
                            </ng-container>
                        </span>
                    </td>
                    <td class="text-center">
                        <span class="font-semibold">{{item.aliquotaIpiNovo | number:'1.2-4'}}</span>
                    </td>
                    <td class="text-center">
                        <p-tag *ngIf="item.ncmEncontrado === false" severity="danger" value="NCM NÃO CADASTRADO"
                            icon="pi pi-times-circle"></p-tag>
                        <p-tag *ngIf="item.ipiDiferente && item.ncmEncontrado !== false" severity="warning"
                            value="DIFERENTE" icon="pi pi-exclamation-triangle"></p-tag>
                        <p-tag *ngIf="!item.ipiDiferente && item.ncmEncontrado !== false" severity="success"
                            value="IGUAL" icon="pi pi-check-circle"></p-tag>
                    </td>
                    <td>
                        <span class="text-sm text-600">{{item.arquivo}}</span>
                    </td>
                    <td>
                        <span class="text-sm">{{item.descricaoNcm || item.descricaoXml}}</span>
                    </td>
                    <td class="text-center">
                        <button *ngIf="item.ipiDiferente && item.ncmEncontrado !== false"
                            pButton type="button" icon="pi pi-sync" (click)="atualizarIpiIndividual(item)"
                            [disabled]="carregandoAtualizacao" class="p-button-rounded p-button-warning p-button-sm"
                            pTooltip="Atualizar Alíquota de IPI" tooltipPosition="left"></button>
                        <button *ngIf="!item.ipiDiferente && item.ncmEncontrado !== false"
                            pButton type="button" icon="pi pi-refresh" (click)="atualizarIpiIndividual(item)"
                            [disabled]="carregandoAtualizacao" class="p-button-rounded p-button-outlined p-button-sm"
                            pTooltip="Reaplicar NCM nos itens (P/Ns) deste NCM" tooltipPosition="left"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" class="text-center">
                        Nenhum resultado encontrado com os filtros aplicados.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Loading Overlay -->
<div *ngIf="carregando" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
    <p class="mt-3 text-white font-semibold">Processando...</p>
</div>
